/* eslint-disable jsx-a11y/anchor-is-valid */
import { IonButton, IonRouterLink, IonToast } from '@ionic/react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { User } from 'model';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { useCountPostsByAuthorQuery } from '../api/PostApi';
import { useGetProfileQuery } from '../api/UserApi';
import { BlockUser } from '../components/BlockUser';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { NoResults } from '../components/NoResults';
import { ProfilePic } from '../components/ProfilePic';
import { IconArrowBack, IconProfile } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { QuirkIonPage } from '../components/QuirkIonPage';
import { QuirkLoader } from '../components/QuirkLoader';
import styles from './ProfilePage.module.css';

export const ProfilePage: React.FC<{}> = () => {
	// check if user is self, can't block self
	const { id } = useParams<{ id: User['_id'] }>();
	const { isError, data: user, isFetching, isLoading: loadingUser, error } = useGetProfileQuery(id);

	const history = useHistory();

	const { data: totalPosts, isLoading: loadingPosts } = useCountPostsByAuthorQuery(id);

	return (
		<QuirkIonPage name="Profile" data={{ user: id }}>
			{user && !isFetching ? (
				<>
					<Header
						title={'profile'}
						left={<IconButton icon={<IconArrowBack />} onClick={() => history.go(-1)} />}
					/>{' '}
					<QuirkIonContent>
						<QuirkLoader
							isLoading={loadingUser || loadingPosts}
							loadingMessage="Loading user..."
							data={user}
							noResults={
								<NoResults
									heading="No user found."
									subheading="Try a different user."
									icon={<IconProfile />}
								/>
							}
						>
							<>
								<div className={styles.profileDetailsContainer}>
									<div className={styles.profilePicContainer}>
										<ProfilePic disableClick user={user} size="large" />
										<h4>{user?.username}</h4>
									</div>
									{user?.description && (
										<div className={styles.descriptionBox}>{user?.description}</div>
									)}
									{totalPosts && (
										<IonRouterLink routerLink={`/main/latest/${id}`}>
											<IonButton
												color="primary"
												fill="solid"
												size="default"
												className="radius8"
												expand="block"
											>
												View {totalPosts.response} posts
											</IonButton>
										</IonRouterLink>
									)}
									<div className={styles.actionButtons}>
										<BlockUser userToBlock={user} />
									</div>
								</div>

								<hr />
							</>
						</QuirkLoader>
					</QuirkIonContent>
					<IonToast
						isOpen={isError}
						duration={1500}
						message={(error as FetchBaseQueryError)?.data as string}
						position="top"
						color="danger"
					/>
				</>
			) : null}
		</QuirkIonPage>
	);
};
